<template>
  <form @submit.prevent="onLogin"
        class="auth">
    <BasePreloader v-if="pendingAuth"/>
    <BaseInput type="tel"
               v-model="inputs.phone.value"
               :error="inputs.phone.error"
               :placeholder="$t('Телефон')"
               mask="+38 (099) 999-99-99"
               class="auth__input"
    />
    <BaseInput type="password"
               v-model="inputs.password.value"
               :error="inputs.password.error"
               :placeholder="$t('Пароль')"
               class="auth__input"
    />
    <div class="auth__forgot-pass-row">
      <a href="#" @click.prevent="onForgotPasswordClick">{{ $t('Забули пароль?') }}</a>
    </div>
    <BaseAlertInline :value="overallErrorsMix" class="_warning"/>
    <div class="auth__buttons">
      <button type="submit"
              class="auth__btn base-btn">
        {{ $t('Вхід') }}
      </button>
      <button type="button" @click.prevent="onRegistrationClick"
              class="auth__btn base-btn"
      >
        {{ $t('Реєстрація') }}
      </button>
    </div>
  </form>
</template>

<script>
  import formMixins from '../mixins/formMixins'
  import {mapState} from 'vuex'

  export default {
    mixins: [formMixins],
    props: {
      redirect: Object
    },
    data() {
      return {
        inputs: {
          phone: {
            value: null,
            required: true
          },
          password: {
            value: null,
            required: true
          }
        }
      }
    },
    computed: {
      ...mapState('user', ['pendingAuth'])
    },
    methods: {
      onLogin() {
        this.resetErrorsMix(this.inputs)
        const sendData = this.createSendDataMix(this.inputs)
        if (!sendData) return
        if (sendData.phone) {
          sendData.phone = `380${sendData.phone}`
        }
        this.$store.dispatch('user/login', sendData).then(() => {
          this.$vModal.close('auth-login')
          if (this.redirect) {
            this.$router.push({name: this.redirect.name})
          }
        }).catch(e => {
          this.handlerErrorMix(e, this.inputs)
        })
      },
      onRegistrationClick() {
        this.$vModal.close('auth-login')
        this.$vModal.open('auth-registration', {
          redirect: this.redirect
        })
      },
      onForgotPasswordClick() {
        this.$vModal.close('auth-login')
        this.$vModal.open('auth-reset-password')
      }
    }
  }
</script>

<style lang="less">

</style>
